import { useContext, useState, useMemo, useRef, useEffect } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import { useNavigate, Link } from 'react-router-dom';
import ValidateService from '../../services/ValidateService';
import LoginController from '../../controllers/member/LoginController';

const Login = () => {
  useEffect(() => {
    document.title = '로그인';
  }, []);

  const { store, updateStore, resetTimer } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);

  const naviagte = useNavigate();
  const [valueObj, setValueObj] = useState({
    userType: 'E',
  });
  const [loginMsgDp, setLoginMsgDp] = useState('');

  const controller = useMemo(() => {
    return new LoginController(
      { store, updateStore, resetTimer },
      modalService,
      validateService,
      naviagte,
      {
        valueObj,
        setValueObj,
      },
      {
        loginMsgDp,
        setLoginMsgDp,
      }
    );
  }, [store, modalService, validateService]);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">로그인</h2>
      </div>
      <div className="tab-area layer">
        <div className="tab line full">
          {/* 기업사용자 로그인만 사용 */}
          {/* <ul role="tablist">
            <li
              id="tab_login_01"
              role="tab"
              aria-selected={valueObj?.userType === 'U'}
              className={valueObj?.userType === 'U' && 'active'}
            >
              <button
                type="button"
                className="btn-tab"
                onClick={() => {
                  controller.valueObjChange('userType', 'U');
                }}
              >
                사용자 로그인
                {valueObj?.userType === 'U' && (
                  <i className="sr-only created">선택됨</i>
                )}
              </button>
            </li>
            <li
              id="tab_login_02"
              role="tab"
              aria-selected={valueObj?.userType === 'E'}
              className={valueObj?.userType === 'E' && 'active'}
            >
              <button
                type="button"
                className="btn-tab"
                onClick={() => {
                  controller.valueObjChange('userType', 'E');
                }}
              >
                기업 사용자 로그인
                {valueObj?.userType === 'E' && (
                  <i className="sr-only created">선택됨</i>
                )}
              </button>
            </li>
          </ul> */}
        </div>
        <div className="tab-conts-wrap">
          <section
            id={`section_login_${valueObj?.userType === 'U' ? '01' : '02'}`}
            role="tabpanel"
            aria-labelledby={`section_login_${
              valueObj?.userType === 'U' ? '01' : '02'
            }`}
            className="tab-conts active"
          >
            {/* 기업사용자 로그인만 사용 */}
            {/* {valueObj?.userType === 'U' ? (
              <>
                <h3 className="sr-only">사용자 로그인</h3>
                <p className="text-gray-70">
                  일반 사용자를 위한 로그인입니다. <br className="br" />
                  로그인을 하시면 보다 더 많은 정보와 서비스를 이용하실 수
                  있습니다.
                </p>
              </>
            ) : (
              <>
                <h3 className="sr-only">기업 사용자 로그인</h3>
                <p className="text-gray-70">
                  기업 사용자를 위한 로그인입니다. <br className="br" />
                  로그인을 하시면 보다 더 많은 정보와 서비스를 이용하실 수
                  있습니다.
                </p>
              </>
            )} */}
            <div className="login-form-area type-tab">
              <div className="login-wrap">
                <div className="in">
                  <fieldset>
                    <legend>로그인 폼</legend>
                    <div className="fieldset">
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="login_id">아이디</label>
                        </div>
                        <div className="form-conts">
                          <input
                            type="text"
                            id="login_id"
                            className="form-control"
                            autoComplete="off"
                            placeholder="영문 소문자"
                            onChange={e => {
                              controller.valueObjChange('id', e.target.value);
                            }}
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                controller.fnLogin();
                              }
                            }}
                            aria-labelledby="login_id"
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="form-tit">
                          <label htmlFor="login_pw">비밀번호</label>
                        </div>
                        <div className="form-conts btn-ico-wrap">
                          <input
                            type="password"
                            id="login_pw"
                            className="form-control"
                            autoComplete="off"
                            placeholder="영문, 숫자, 특수문자를 포함하여 8자 이상 20자 이내"
                            onChange={e => {
                              controller.valueObjChange(
                                'password',
                                e.target.value
                              );
                            }}
                            onKeyDown={e => {
                              if (e.key === 'Enter') {
                                controller.fnLogin();
                              }
                            }}
                            aria-labelledby="login_pw"
                          />
                          {loginMsgDp.length > 0 && (
                            <p
                              className="text-point"
                              dangerouslySetInnerHTML={{
                                __html: loginMsgDp,
                              }}
                            ></p>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn primary"
                          onClick={() => controller.fnLogin()}
                        >
                          로그인
                        </button>
                      </div>
                      <div className="form-group">
                        <ul className="link-group">
                          <li>
                            <Link
                              to="/member/findId"
                              className="btn md btn-txt"
                            >
                              아이디 찾기
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/member/findPassword"
                              className="btn md btn-txt"
                            >
                              비밀번호 찾기
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/member/joinPage"
                              className="btn md btn-txt"
                            >
                              회원가입
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Login;
